import React, { Component } from 'react';

class About extends Component {
  renderParagraphs(paragraphs) {
    if (!Array.isArray(paragraphs)) {
      return <p>{paragraphs}</p>;
    }

    return paragraphs.map(function(paragraph) {
      return <p key={paragraph}>{paragraph}</p>;
    });
  }

  renderFocusAreas(areas) {
    if (!Array.isArray(areas)) {
      return null;
    }

    return areas.map(function(area) {
      return (
        <article className="focus-card" key={area.title}>
          <span className="focus-marker">{area.marker}</span>
          <h3>{area.title}</h3>
          <p>{area.description}</p>
        </article>
      );
    });
  }

  render() {
    var data = this.props.data || {};
    var address = data.address || {};

    return (
      <section id="about" className="section profile-section">
        <div className="section-heading">
          <p className="eyebrow">Profile</p>
          <h2>Data architecture for teams that need clarity, scale, and trust.</h2>
        </div>

        <div className="profile-grid">
          <div className="profile-copy">
            {this.renderParagraphs(data.bio)}
          </div>

          <aside className="contact-card">
            <h3>Contact Details</h3>
            <dl>
              <div>
                <dt>Email</dt>
                <dd><a href={'mailto:' + data.email}>{data.email}</a></dd>
              </div>
              <div>
                <dt>Location</dt>
                <dd>{address.city}, {address.state}, Australia</dd>
              </div>
              <div>
                <dt>YouTube</dt>
                <dd><a href={data.youtube} target="_blank" rel="noreferrer">@rajtdkr</a></dd>
              </div>
            </dl>
          </aside>
        </div>

        <div className="focus-grid">
          {this.renderFocusAreas(data.focusAreas)}
        </div>
      </section>
    );
  }
}

export default About;
